module.exports = __webpack_public_path__ + "img/pay2.55d5ed80.png";